import {RepositorioComponent} from "../components/RepositorioComponent";
import Layout from "../components/Layout";

export default function RepositorioCredito() {

  return (
	<div>
		<Layout />
		<div>
			<RepositorioComponent />
		</div>
	</div>
  );
}